<div class="modal-header">
    <h5 class="modal-title" id="image-gallery-title">
        {{ title() }}
        @if (orderedImages().length) {
            <span class="badge text-bg-secondary ms-1">{{ orderedImages().length }}</span>
        }
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
    @if (selectedImage(); as image) {
        <div class="gallery-viewer">
            <div
                #stage
                class="gallery-viewer__stage"
                tabindex="-1"
                role="group"
                ngbAutofocus
                [attr.aria-label]="stageLabel()">
                @if (failedImageIds().has(image.id)) {
                    <div class="gallery-placeholder text-white-50">
                        <fa-icon icon="image" size="3x"></fa-icon>
                        <span>Image unavailable</span>
                    </div>
                } @else {
                    <img
                        class="gallery-viewer__image"
                        [src]="image.url"
                        [alt]="image.title"
                        (error)="onImageError(image)" />
                }

                @if (orderedImages().length > 1) {
                    <!-- Wrapped because sfButton adds position-relative to its host -->
                    <div class="gallery-viewer__nav gallery-viewer__nav--previous">
                        <button
                            sfButton
                            type="button"
                            color="dark"
                            icon="chevron-left"
                            aria-label="Previous image"
                            (click)="showPrevious()"></button>
                    </div>
                    <div class="gallery-viewer__nav gallery-viewer__nav--next">
                        <button
                            sfButton
                            type="button"
                            color="dark"
                            icon="chevron-right"
                            aria-label="Next image"
                            (click)="showNext()"></button>
                    </div>
                }
            </div>

            <div class="d-flex align-items-center gap-2 mt-2">
                <button
                    sfButton
                    type="button"
                    color="secondary"
                    icon="table-cells"
                    iconOnlyMediaSize="sm"
                    aria-label="All images"
                    (click)="showThumbnails()">
                    All images
                </button>
                <div class="gallery-viewer__caption text-center" aria-live="polite" aria-atomic="true">
                    <div class="fw-semibold text-break">{{ image.title }}</div>
                    <div class="small text-body-secondary">{{ positionLabel() }}</div>
                </div>
                <a
                    sfButton
                    color="dark"
                    variant="outline"
                    icon="up-right-from-square"
                    iconOnlyMediaSize="sm"
                    aria-label="Open original (opens in a new tab)"
                    [href]="image.url"
                    target="_blank"
                    rel="noopener">
                    Open original
                </a>
            </div>
        </div>
    } @else if (orderedImages().length === 0) {
        <sf-empty message="No images to show" [icon]="emptyIcon" />
    } @else {
        <div class="row g-2">
            @for (image of orderedImages(); track image.id) {
                <div class="col-6 col-sm-4 col-md-3 col-xl-2">
                    <button
                        #thumbnail
                        type="button"
                        class="gallery-thumbnail"
                        [attr.data-image-id]="image.id"
                        [attr.aria-label]="image.title ? null : 'Image ' + ($index + 1)"
                        [title]="image.title"
                        (click)="view(image)">
                        <div class="ratio ratio-1x1">
                            @if (failedImageIds().has(image.id)) {
                                <div class="gallery-placeholder text-body-secondary">
                                    <fa-icon icon="image" size="2x"></fa-icon>
                                </div>
                            } @else {
                                <!-- Empty alt as the title below already names the button -->
                                <img
                                    class="gallery-thumbnail__image"
                                    [src]="image.url"
                                    alt=""
                                    loading="lazy"
                                    (error)="onImageError(image)" />
                            }
                        </div>
                        <span class="gallery-thumbnail__title">{{ image.title }}</span>
                    </button>
                </div>
            }
        </div>
    }
</div>
